var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTypeFavorite)?_c('div',{staticClass:"favorite-common",on:{"click":function($event){return _vm.changeState()}}},[(_vm.$route.name === 'favoritesList')?_c('img',{attrs:{"src":_vm.img.remove,"width":"12"}}):_c('img',{attrs:{"src":_vm.imgStar,"width":"14"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }